<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { FaqBlock } from '../../types'

defineProps<{ block: FaqBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-surface) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container">
      <div class="site:mx-auto site:max-w-3xl site:text-center">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mt-5 site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
      </div>

      <div class="site:mt-10 site:grid site:gap-x-12 site:gap-y-8 site:@min-[48rem]:grid-cols-2">
        <article v-for="item in block.content.items" :key="item.id" class="site:border-t site:border-(--site-color-border) site:pt-6">
          <SiteEditableText v-model="item.question" as="h3" class="site-heading site:text-lg site:font-bold" />
          <SiteEditableText v-model="item.answer" as="p" class="site:mt-3 site:leading-7 site:text-(--site-color-muted-text)" />
        </article>
      </div>

      <div v-if="block.content.action" class="site:mt-10 site:text-center">
        <SiteLink :link="block.content.action" class="site-site-button-secondary">{{ block.content.action.label }}</SiteLink>
      </div>
    </div>
  </section>
</template>
